import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { ModelDialogType } from '../models/menu';

@Injectable()

export class DialogService {
    inputData: Subject<ModelDialogType> = new Subject<ModelDialogType>();

    /**
     * This function is used to get the input data from the components
     */
    public showDialog(dialogInput: ModelDialogType): void {
        dialogInput.visible = true;
        this.inputData.next(dialogInput);
    }

    public getData(): Observable<ModelDialogType> {
        return this.inputData.asObservable();
    }

}
